/**
 * The one bar a report's controls live in: the date range first, then the
 * report's filters, then its actions and the refresh button on the right — the
 * same order, size and refresh behaviour on every page that uses it.
 *
 * Built for the Traffic page, which had two date pickers and two refresh
 * buttons (one in the header, one above the summary) and its source filter
 * three sections further down, next to the tabs.
 */
import { DateRangePicker } from './DateRangePicker'
import { Button } from './ui'
import { RefreshCw, Loader2 } from 'lucide-react'

export default function ReportToolbar({ dateRange, onDateRangeChange, onRefresh, refreshing = false, children, actions }) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border bg-card p-2">
      <DateRangePicker dateRange={dateRange} onDateRangeChange={onDateRangeChange} />
      {children}
      <div className="ml-auto flex items-center gap-2">
        {actions}
        {onRefresh && (
          <Button
            variant="outline"
            size="icon"
            onClick={onRefresh}
            disabled={refreshing}
            className="h-9 w-9"
            title="Refresh"
          >
            {refreshing ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
          </Button>
        )}
      </div>
    </div>
  )
}
